const alphabetLetter = document.querySelectorAll(".alphabet-letter");
if (!alphabetLetter) return;

alphabetLetter.forEach((letter) => {
  letter.addEventListener("click", (e) => {
    const letterValue = e.target.textContent.trim();
    const teamSort = document.querySelector(`.team-sort-${letterValue}`);

    if (!teamSort) return;

    window.scrollTo({
      top: teamSort.offsetTop,
      behavior: "smooth",
    });
  });
});
